import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-journal-steps',
  templateUrl: './journal-steps.component.html',
  styleUrls: ['./journal-steps.component.scss']
})
export class JournalStepsComponent {

  @Input() sectionTitle: string = '';
  @Input() sectionDescription: string = ''; 

  @Input() stepDescription1: string = ''; 
  @Input() stepDescription2: string = ''; 
  @Input() stepDescription3: string = ''; 

}
